import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(main)/hop-am-guitar/client.tsx");
